// extracted by mini-css-extract-plugin
module.exports = {"container":"BigFiveTest_container__1ZYKX"};